import { render, staticRenderFns } from "./RecipeSteps.vue?vue&type=template&id=21880238&scoped=true&"
import script from "./RecipeSteps.vue?vue&type=script&lang=ts&"
export * from "./RecipeSteps.vue?vue&type=script&lang=ts&"
import style0 from "./RecipeSteps.vue?vue&type=style&index=0&id=21880238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21880238",
  null
  
)

export default component.exports